export function signinBuilder(pathname: string, searchParams?: string, expired?: boolean): string {
  const params = new URLSearchParams();
  const illegalDesinations = ["/signin", "/logout"];
  const destination = illegalDesinations.includes(pathname) ? undefined : pathname + searchParams;

  if (destination) {
    params.append("destination", destination);
  }

  if (expired) {
    params.append("expired", "true");
  }

  return `/signin?${params.toString()}`;
}

export function redirectToSignin() {
  if (window.location.pathname !== "/signin") {
    const url = signinBuilder(window.location.pathname, window.location.search, true);
    window.location.href = url;
  }
}
